import MaterialMenu, { MenuProps } from '@mui/material/Menu';

export function Menu(props: MenuProps) {
    return <MaterialMenu data-testid={'Menu-container'} {...props} />;
}

export default Menu;
